export default __webpack_public_path__ + "static/media/tweet_1.8641cdc2.png";